export const collectionsData = [
  {
    id: 1,
    title: "The Best Garhwali Stories",
    images:
      "./images/home/collagesuno.png",
    link: "language/garhwali",
  },
  {
    id: 2,
    title: "Top Love Stories",
    images:
    "./images/home/collagesuno.png",

    link: "category/love",
  },
  {
    id: 3,
    title: "The Best of Horror Stories",
    images:
    "./images/home/collagesuno.png",

    link: "category/horror",
  },
  {
    id: 4,
    title: "The Best of Crime Stories",
    images:
    "./images/home/collagesuno.png",

    link: "category/crime",
  },
  {
    id: 5,
    title: "The Best of Kids Stories",
    images:
    "./images/home/collagesuno.png",

    link: "category/kids",
  },
];
